import React from 'react'
import useStyles from './ReportsDockBody.styles'

type Props = {
  children: React.ReactNode
  width: number
}

function ReportsDockBody(props: Props) {
  const {children, width} = props
  const classes = useStyles()

  return (
    <div className={classes.root} style={{width}}>
      {children}
    </div>
  )
}

export default ReportsDockBody
